// frontend/src/components/ChatPage.js
import React, { useRef,useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { chatQuery, logout, sendFeedback } from "../services/api";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
const ChatPage = () => {
 const location = useLocation();
 const navigate = useNavigate();
 // state
 const [ntid] = useState(location.state?.ntid || "");
 const [category, setCategory] = useState("TDS");
 const [query, setQuery] = useState("");
 const [chatHistory, setChatHistory] = useState([]);
 const [isTyping, setIsTyping] = useState(false);
 const [error, setError] = useState("");
 const [bookmarks, setBookmarks] = useState([]);
 const chatEndRef = useRef(null);
 // prevent back button leaving chat (keeps behaviour you had)
 useEffect(() => {
   const handlePopState = () => window.history.pushState(null, "", window.location.href);
   window.history.pushState(null, "", window.location.href);
   window.addEventListener("popstate", handlePopState);
   return () => window.removeEventListener("popstate", handlePopState);
 }, []);
 const handleSendQuery = async () => {
   if (!query.trim()) return;
   setIsTyping(true);
   setError("");
   try {
     const data = await chatQuery(query, category, "", "default");
     setChatHistory((prev) => [
       ...prev,
       {
         user: query,
         bot: data?.answer || "No response",
         documents: data?.documents || [],
       },
     ]);
     setQuery("");
   } catch (e) {
     setError("Error fetching response.");
   } finally {
     setIsTyping(false);
   }
 };
 const handleKeyDown = (e) => e.key === "Enter" && handleSendQuery();
 const handleChatAction = async (index, action) => {
   setIsTyping(true);
   try {
     const baseUser = chatHistory[index]?.user || "";
     const data = await chatQuery(baseUser, category, "", action);
     setChatHistory((prev) => {
       const updated = [...prev];
       updated[index].bot = data?.answer;
       updated[index].documents = data?.documents || [];
       return updated;
     });
   } catch {
     setError(`Error performing ${action}.`);
   } finally {
     setIsTyping(false);
   }
 };
 const categories = [
  //  "GST",
   "Login process for EU and UK",
   "Login process",
   "UW guidelines",
   "TDS",
   "Investment plans",
   "FAQs",
   "Servicing",
 ];
 return (
<div style={{ display: "flex", height: "100vh" }}>
     {/* Sidebar stays visible; bookmarks panel collapses nicely on small screens via CSS */}
{/* <Sidebar showAuthButtons={true} showBookmarks={true} bookmarks={bookmarks} /> */}
<Sidebar showBookmarks={true} bookmarks={bookmarks} />

<div className="chat-container">
       {/* Header */}
<div className="chat-header">
<img src="/nova_logo_transparent.png" alt="NOVA Logo" className="nova-logo" />
<div className="header-controls">
           {/* Category on the left in desktop; stacks on mobile via CSS */}
<select
             className="category-dropdown"
             value={category}
             onChange={(e) => setCategory(e.target.value)}
>
             {categories.map((cat) => (
<option key={cat} value={cat}>
                 {cat}
</option>
             ))}
</select>
{/* <button
             className="header-btn"
             onClick={() => logout().then(() => navigate("/"))}
>
             Logout
</button> */}
</div>
</div>
       {/* Messages */}
<div className="chat-messages">
         {chatHistory.map((entry, index) => (
<div key={index} className="chat-entry">
<div className="chat-bubble user-bubble">
<p>
<strong>You:</strong> {entry.user}
</p>
</div>
<div className="chat-bubble bot-bubble">
<ReactMarkdown
                 remarkPlugins={[remarkGfm]}
                 rehypePlugins={[rehypeRaw]}
                 components={{
                   a: ({ node, ...props }) => (
<a {...props} target="_blank" rel="noopener noreferrer" />
                   ),
                 }}
>
                 {`**NOVA:** ${entry.bot}`}
</ReactMarkdown>
               {/* Source docs */}
               {Array.isArray(entry.documents) && entry.documents.length > 0 && (
<div className="source-documents">
                   {entry.documents.map((doc, i) => (
<p key={i} className="source-document">
<a href={doc.url} target="_blank" rel="noopener noreferrer">
                         {doc.name || "View Document"}
</a>
</p>
                   ))}
</div>
               )}
               {/* Action buttons */}
<div className="feedback-buttons">
                 {["helpful", "not_helpful"].map((type) => (
<button
                     key={type}
                     className="button secondary"
                     onClick={() => sendFeedback(entry.user, entry.bot, type)}
>
                     {type === "helpful" ? "👍 Helpful" : "👎 Not Helpful"}
</button>
                 ))}
<button
                   className="button secondary"
                   onClick={() => handleChatAction(index, "simplify")}
>
                   ✂️ Simplify
</button>
<button
                   className="button secondary"
                   onClick={() => handleChatAction(index, "summarize")}
>
                   📝 Summarize
</button>
<button
                   className="button secondary"
                   onClick={() => setBookmarks((bms) => [...bms, entry.bot])}
>
                   ⭐ Bookmark
</button>
</div>
</div>
</div>
         ))}
         {isTyping && <p className="typing-animation">Nova is typing...</p>}
         <div ref={chatEndRef} />
</div>
       {/* Input */}
<div className="chat-input-container">
<input
           className="input-field"
           type="text"
           value={query}
           onChange={(e) => setQuery(e.target.value)}
           placeholder="Type your question..."
           onKeyDown={handleKeyDown}
           onFocus={() => {
            setTimeout(() => {
              chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
            }, 300);
           }}
         />
<button className="button primary" onClick={handleSendQuery}>
           Send
</button>
</div>
       {error && <p className="error-text">{error}</p>}
</div>
</div>
 );
};
export default ChatPage;